import { Controllers, Hyperlink } from "@infoland/iprova-api";
import Shared from "./shared";

export default async (to, from, next) => {
    let hyperlinkId: string = to.params.hyperlink_id;
    let new_tab: boolean = to.params.new_tab == "false" ? false : true;

    let hyperlinkData: Hyperlink = await Controllers.HyperlinksController.getHyperlinkAsync(hyperlinkId);
    if (hyperlinkData !== null) {
        switch (hyperlinkData.target_type) {
            case "Global.WebPage":
                window.open(hyperlinkData.target_url, "_blank");
                next(false); //abort the current navigation
                break;

            case "Global.EmailAddress":
                window.open("mailto:" + hyperlinkData.target_url, "_self");
                next(false); //abort the current navigation
                break;

            default:
                window.open(`${Shared.iProvaUrl}/Management/HyperlinkLoader.aspx?HyperlinkID=${hyperlinkId}`, !new_tab ? "_self" : "_blank");
                next(false); //abort the current navigation
                break;
        }
    }
};
